import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import noopStorage from "@/store/storage/noopStorage";
import {createSelector} from "reselect";

const initialState: Object = {

};

export const tempSlice = createSlice({
    name: 'temp',
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<object>) => {
            // @ts-ignore
            setTempData(state, action.payload.key, action.payload.value);
        },

    },
});

function setTempData(object: Object, key: string, value: any)
{
    var keys = key.split('.');

    while (keys.length > 1) {
        var k = keys.shift();

        // @ts-ignore
        if (!object.hasOwnProperty(k)) {
            // @ts-ignore
            object[k] = {};
        }

        // @ts-ignore
        if (typeof object[k] !== "object"){
            // @ts-ignore
            object[k] = {};
        }
        // @ts-ignore
        object = object[k];
    }
    // @ts-ignore
    return object[keys[0]] = value;
}

// const getTempData = (object: Object, key: string) =>{
//     var keys = key.split('.');
//
//     while (keys.length > 1) {
//         var k = keys.shift();
//
//         if (object.hasOwnProperty(k)) {
//             object = object[k];
//         }
//     }
//
//     return object[keys[0]];
// }

// Action creators are generated for each case reducer function
export const {
    setData,
} = tempSlice.actions;

const tempReducer = tempSlice.reducer;

const tempPersistConfig = {
    key: 'temp',
    storage: noopStorage,
    whitelist: [''],
};

export const selectTempSelector = createSelector(
    (state) => state.temp,
    (global) => global
)

export const tempPersistReducer = persistReducer(tempPersistConfig, tempReducer)